import { Box, Divider, Grid, Typography } from "@mui/material";
import KpiCard from "./KpiCard/KpiCard";

export default function DiscountOverview() {
	return (
		<Box mt={5} width={"100%"}>
			{/* Center Title */}
			<Typography align="center" variant="caption" color="text.secondary" sx={{ my: 1 }}>
				<Divider>Thor Level Data</Divider>
			</Typography>
			{/* Row 1 */}
			<Grid container spacing={2}>
				<Grid item xs={4}>
					<KpiCard title="MTD" />
				</Grid>
				<Grid item xs={4}>
					<KpiCard title="Season" />
				</Grid>
				<Grid item xs={4}>
					<KpiCard title="YTD" />
				</Grid>
			</Grid>

			{/* Center Title */}
			<Typography align="center" variant="caption" color="text.secondary" sx={{ my: 1 }}>
				<Divider>Thor Level Data</Divider>
			</Typography>

			{/* Row 2 */}
			<Grid container spacing={2}>
				<Grid item xs={4}>
					<KpiCard title="MTD" showVsAop />
				</Grid>
				<Grid item xs={4}>
					<KpiCard title="Season" showVsAop />
				</Grid>
				<Grid item xs={4}>
					<KpiCard title="YTD" showVsAop />
				</Grid>
			</Grid>
		</Box>
	);
}
